export enum ModelType {
    Holdings = 'Holdings',
    ModelOfModels = 'ModelOfModels',
}

export const MODEL_TYPES: { label: string; value: string }[] = [
    { label: 'Holdings Model', value: ModelType.Holdings },
    { label: 'Model of Models', value: ModelType.ModelOfModels },
];
